var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navi-serchnavi-area-links',[_c('img',{staticClass:"map sp",attrs:{"src":require("@/assets/assets/imgs/map01.png"),"alt":""}}),_c('img',{staticClass:"map pc",attrs:{"src":require("@/assets/assets/imgs/map03.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }